 import Swiper from 'swiper/bundle';
  // import Swiper and modules styles

  class Swip {
    constructor() {
      if (document.querySelector(".partners__list")) {

        const swiper = new Swiper('.partners__list', {
            loop: true,
  				slidesPerView: 8,
  				speed: 500,
  				observer: true,
  				observeParents: true,

          });

    }

    }
  }

export default Swip
